module.exports = __webpack_public_path__ + "static/img/15073C_1_2_C_20240624_LC.5198860.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/15073C_1_2_C_20240624_LC.png
// module id = ox2r
// module chunks = 0